/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "skills";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface UiRadioStyle {
}

export enum UiRadioStyle_Enum {
  DETAILED = 0,
  NAME_ONLY = 1,
  IMAGE_GRID = 2,
  IMAGE_GRID_PICKER = 3,
  UNRECOGNIZED = -1,
}

export function uiRadioStyle_EnumFromJSON(object: any): UiRadioStyle_Enum {
  switch (object) {
    case 0:
    case "DETAILED":
      return UiRadioStyle_Enum.DETAILED;
    case 1:
    case "NAME_ONLY":
      return UiRadioStyle_Enum.NAME_ONLY;
    case 2:
    case "IMAGE_GRID":
      return UiRadioStyle_Enum.IMAGE_GRID;
    case 3:
    case "IMAGE_GRID_PICKER":
      return UiRadioStyle_Enum.IMAGE_GRID_PICKER;
    case -1:
    case "UNRECOGNIZED":
    default:
      return UiRadioStyle_Enum.UNRECOGNIZED;
  }
}

export function uiRadioStyle_EnumToJSON(object: UiRadioStyle_Enum): string {
  switch (object) {
    case UiRadioStyle_Enum.DETAILED:
      return "DETAILED";
    case UiRadioStyle_Enum.NAME_ONLY:
      return "NAME_ONLY";
    case UiRadioStyle_Enum.IMAGE_GRID:
      return "IMAGE_GRID";
    case UiRadioStyle_Enum.IMAGE_GRID_PICKER:
      return "IMAGE_GRID_PICKER";
    case UiRadioStyle_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseUiRadioStyle(): UiRadioStyle {
  return {};
}

export const UiRadioStyle = {
  encode(_: UiRadioStyle, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UiRadioStyle {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUiRadioStyle();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): UiRadioStyle {
    return {};
  },

  toJSON(_: UiRadioStyle): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<UiRadioStyle>, I>>(base?: I): UiRadioStyle {
    return UiRadioStyle.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UiRadioStyle>, I>>(_: I): UiRadioStyle {
    const message = createBaseUiRadioStyle();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
